import React, { useContext, useEffect } from 'react';
import styles from './Help.scss';
import themeStyles from '../../_theme.scss';
import {
    POL_THEME,
    MCO_THEME,
    ThemeContext,
} from '../../constants/theme';
import Button from '../shared/Button';
import { Titles } from '../../constants/titles';
import { AppContext } from '../../context/AppContext';
import { Descriptions } from '../../constants/Descriptions';

// Image for the POL version
const polImgUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/pol-register-as-parish-staff-link.png`;
const polcopyWidgetCodeUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/POL_Widget_Code.jpg`;
const polsubscribeUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/POL_Subscribe.jpg`;
const polmanagePublicationsUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/POL_Manage_Publications.jpg`;
const poladdFileUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/POL_manage_AddFile.jpg`;
const polgetWidgetUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/POL_Get_Widgets.jpg`;
// Image for the MCO version
const mcoImgUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/mco-register-as-staff-link.png`;
const mcocopyWidgetCodeUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/MCO_Copy_Widget_Code.jpg`;
const mcosubscribeUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/MCO_Subscribe.jpg`;
const mcomanagePublicationsUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/MCO_Manage_Publications.jpg`;
const mcoaddFileUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/MCO_manage_AddFile.png`;
const mcogetWidgetUrl = `${process.env.CUSTOMER_DATA_S3_URL}/help/MCO_Get_Widgets.jpg`;

const Help = () => {
    const themeContext = useContext(ThemeContext);
    const { setPageTitle, setPageDescription } = useContext(AppContext);

    useEffect(() => {
        switch (themeContext) {
            case MCO_THEME:
                setPageTitle(Titles.MCO_HELP);
                setPageDescription(Descriptions.MCO_HELP);
                break;
            case POL_THEME:
                setPageTitle(Titles.POL_HELP);
                setPageDescription(Descriptions.POL_HELP);
                break;
            default:
                break;
        }
    }, [themeContext, setPageTitle, setPageDescription]);

    let siteName = '';
    let siteURL = '';
    let siteExternalURL = '';
    let siteStripedURLPretty = '';
    let parishOrgName = '';
    let parishCommunityName = '';
    let congregationOrgName = '';
    let churchCommunityName = '';
    let churchOrgName = '';
    let churchCommunityNamePlural = '';
    let orgPlural = '';
    let pubTypeName = '';
    let pubTypeNameAlt = '';
    let bulletinsPublicationsName = '';
    let multiPubs = '';
    let catholicCommunityName = '';
    let orgList = '';
    let bulletinNewsPub = '';
    let listingOwnerText = '';
    let registerLinkText = '';
    let verifyText = '';
    let howPostText = '';
    let usefulText = '';
    let supportImage = '';
    let headlineColor = '';
    let widgetCodeUrlImg = '';
    let subscribeUrlImg = '';
    let managePublicationsUrlImg = '';
    let addFileUrlImg = '';
    let getWidgetUrlImg = '';

    if (themeContext === POL_THEME) {
        siteName = 'Parishes Online';
        siteExternalURL = 'https://4lpi.com/';
        siteURL = 'https://www.parishesonline.com';
        siteStripedURLPretty = 'ParishesOnline.com';
        parishOrgName = 'parish';
        parishCommunityName = 'parish';
        congregationOrgName = 'congregation';
        churchCommunityName = 'church';
        churchOrgName = 'church';
        churchCommunityNamePlural = 'churches';
        orgPlural = 'parishes';
        pubTypeName = 'bulletin';
        pubTypeNameAlt = 'bulletin';
        bulletinsPublicationsName = 'bulletins or publications';
        multiPubs = 'bulletin';
        catholicCommunityName = 'Catholic parishes';
        orgList = 'church or business';
        bulletinNewsPub = 'bulletin or newsletter';
        // eslint-disable-next-line
        listingOwnerText = 'As the listing owner, you can edit contact information, publications, office hours, and more. ';
        registerLinkText = 'Register as Parish Staff';
        verifyText = 'We must verify your e-mail address as being associated with your church name';
        howPostText = 'bulletins or publications on Parishes Online';
        // eslint-disable-next-line
        usefulText = "By publicizing the businesses in your area that support your local congregation, Parishes Online informs and empowers consumers to make educated decisions about the businesses they choose to visit. Many parishioners wish to show their appreciation by patronizing businesses that help to fund their parish bulletin. Since these businesses are community members that live in your area, many wish to support local small businesses with their consumer dollars."
        supportImage = polImgUrl;
        headlineColor = styles.polHeadline;
        widgetCodeUrlImg = polcopyWidgetCodeUrl;
        subscribeUrlImg = polsubscribeUrl;
        managePublicationsUrlImg = polmanagePublicationsUrl;
        addFileUrlImg = poladdFileUrl;
        getWidgetUrlImg = polgetWidgetUrl;
    } else {
        siteName = 'My Community Online';
        siteExternalURL = 'https://www.lpicommunities.com/';
        siteURL = 'https://www.mycommunityonline.com';
        // siteURLPretty = 'www.lpicommunities.com.';
        siteStripedURLPretty = 'MyCommunityOnline.com';
        // parishBusinessName = 'business';
        parishOrgName = 'organization';
        parishCommunityName = 'community';
        congregationOrgName = 'organization';
        churchCommunityName = 'community';
        churchOrgName = 'organization';
        churchCommunityNamePlural = 'communities';
        orgPlural = 'communities';
        pubTypeName = 'newsletter';
        pubTypeNameAlt = 'publication';
        bulletinsPublicationsName = 'publications';
        multiPubs = 'publication';
        catholicCommunityName = 'community organizations';
        orgList = 'community, business, or organization';
        bulletinNewsPub = 'publication';
        // eslint-disable-next-line
        listingOwnerText = 'As the listing owner, you can edit contact information, publications, office hours, and more.';
        registerLinkText = 'Register as Staff';
        verifyText = 'We must verify your e-mail address as being associated with your community/organization name';
        howPostText = 'publications on MyCommunityOnline';
        // eslint-disable-next-line
        usefulText = "By publicizing the businesses in your area that support your local organization, My Community Online informs and empowers consumers to make educated decisions about the businesses they choose to visit. Many community members wish to show their appreciation by patronizing businesses that help to fund their community’s newsletter. Since these businesses are community members who live in your area, many wish to support local small businesses with their consumer dollars."
        supportImage = mcoImgUrl;
        headlineColor = styles.mcoHeadline;
        widgetCodeUrlImg = mcocopyWidgetCodeUrl;
        subscribeUrlImg = mcosubscribeUrl;
        managePublicationsUrlImg = mcomanagePublicationsUrl;
        addFileUrlImg = mcoaddFileUrl;
        getWidgetUrlImg = mcogetWidgetUrl;
    }

    return (
        <div className={themeStyles.outerContainer}>
            <main className={styles.container}>
                <header className={`${themeStyles.headerWrapper} ${styles.headerWrapper}`}>
                    <h1 className={`${themeStyles.primaryHeader} ${themeStyles.headerText}`}>
                        Frequently Asked Questions
                    </h1>
                </header>

                <section className={styles.faqMenuContainer}>
                    <ul className={styles.faqMenu}>
                        <li>
                            <a href="#what-is">
                                What is&nbsp;
                                {siteName}
                                ?
                            </a>
                        </li>
                        <li>
                            <a href="#useful-consumer">
                                How is&nbsp;
                                {siteName}
                                {' '}
                                useful to me as a consumer?
                            </a>
                        </li>
                        <li>
                            <a href="#useful-business-owner">
                                How is&nbsp;
                                {' '}
                                {siteName}
                                {' '}
                                useful to me as a business owner?
                            </a>
                        </li>
                        <li>
                            <a href="#search-results">
                                Why can’t I find the business or
                                {' '}
                                {churchCommunityName}
                                {' '}
                                I’m looking for?
                            </a>
                        </li>
                        <li>
                            <a href="#find-church">
                                How do I find my&nbsp;
                                {churchCommunityName}
                                ?
                            </a>
                        </li>
                        <li>
                            <a href="#bulletin-notification">
                                How do I sign up to be notified when a new
                                {' '}
                                {multiPubs}
                                {' '}
                                is posted?
                            </a>
                        </li>
                        <li><a href="#find-business">How do I find a business?</a></li>
                        <li>
                            <a href="#existing-listing">
                                How did my business or
                                {' '}
                                {churchOrgName}
                                {' '}
                                get on
                                {' '}
                                {siteName}
                                ?
                            </a>
                        </li>
                        <li><a href="#claim-listing">How do I claim my listing?</a></li>
                        <li><a href="#edit-listing">How can I edit the information on my listing?</a></li>
                        <li><a href="#forgot-login">I forgot my login information.</a></li>
                        <li>
                            <a href="#post-bulletins">
                                How do I post my
                                {' '}
                                {bulletinsPublicationsName}
                                {' '}
                                on
                                {' '}
                                {siteName}
                                ?
                            </a>
                        </li>
                        <li>
                            <a href="#bulletin-duration">
                                How long will published
                                {' '}
                                {pubTypeName}
                                s
                                {' '}
                                stay on my
                                {' '}
                                {siteName}
                                {' '}
                                &nbsp;listing?
                            </a>
                        </li>
                        <li>
                            <a href="#bulletin-changes">
                                Can I make changes to
                                {' '}
                                {pubTypeNameAlt}
                                s
                                that are already published online?
                            </a>
                        </li>
                        <li>
                            <a href="#bulletin-display">
                                Can I get my
                                {' '}
                                {pubTypeNameAlt}
                                {' '}
                                to display on my
                                {' '}
                                {churchCommunityName}
                                &apos;s
                                website?
                            </a>
                        </li>
                    </ul>
                </section>

                <section className={styles.faqContentContainer}>
                    <h3 className={styles.helpQuestions} id="what-is">
                        What is&nbsp;
                        {siteName}
                        ?
                    </h3>
                    <p>
                        {siteName}
                        {' '}
                        connects an online community of businesses, and the local&nbsp;
                        {congregationOrgName}
                        s they support.
                        {' '}
                        {siteName}
                        {' '}
                        publicizes the businesses in your area that support your
                        local
                        {' '}
                        {parishOrgName}
                        {' '}
                        - these are community members that live in your area and fund the
                        printing of your
                        {' '}
                        {parishOrgName}
                        &apos;s
                        {' '}
                        {pubTypeName}
                        . When you are making purchases or
                        looking for services, wouldn&apos;t you feel better patronizing businesses that
                        support your community?
                        {' '}
                        {siteName}
                        {' '}
                        can help you do just that.
                    </p>
                    <p>
                        Every
                        {' '}
                        {congregationOrgName}
                        {' '}
                        who publishes with&nbsp;
                        <a href={siteExternalURL} rel="noreferrer" target="_blank">LPi</a>
                        {' '}
                        has a listing page on
                        {' '}
                        {siteName}
                        , and so does every business that advertises with us.
                        These listing pages are maintained by
                        {' '}
                        {siteName}
                        , but once you&nbsp;
                        <a href="#claim-listing">claim your listing</a>
                        , you can customize it to best serve your community.
                    </p>
                    <h3 className={styles.helpQuestions} id="useful-consumer">
                        How is&nbsp;
                        {siteName}
                        {' '}
                        useful to me as a consumer?
                    </h3>
                    <p>
                        {usefulText}
                    </p>
                    <h3 className={styles.helpQuestions} id="useful-business-owner">
                        How is&nbsp;
                        {siteName}
                        {' '}
                        useful to me as a business owner?
                    </h3>
                    <p>
                        {siteName}
                        {' '}
                        gives your business a presence online. Every business that advertises in
                        one of our publications has a listing page on&nbsp;
                        {siteName}
                        . When you&nbsp;
                        <a href="#claim-listing">claim your listing page</a>
                        , you are able to customize it to fit your needs.
                    </p>

                    <h3 className={styles.helpQuestions} id="search-results">
                        Why can’t I find the business or
                        {' '}
                        {churchCommunityName}
                        {' '}
                        I’m looking for?
                    </h3>
                    <p>
                        Search results are listed based on proximity to your location.
                        If no results show up, it&apos;s possible your
                        {' '}
                        {congregationOrgName}
                        {' '}
                        doesn&apos;t print its publications with LPi, or the
                        business you are searching for doesn&apos;t advertise in one of the publications we
                        print.
                    </p>

                    <h3 className={styles.helpQuestions} id="find-church">
                        How do I find my&nbsp;
                        {churchCommunityName}
                        ?
                    </h3>
                    <p>
                        You may search by entering the name of the
                        {' '}
                        {churchCommunityName}
                        {' '}
                        in the search bar and the city, state, and/or zip
                        code where the
                        {' '}
                        {churchCommunityName}
                        {' '}
                        is located, or you can search for
                        {' '}
                        {orgPlural}
                        {' '}
                        using only the location field. If no
                        {' '}
                        {orgPlural}
                        {' '}
                        are available that fit your search parameters, you could
                        adjust your search or search a different
                        {' '}
                        {parishCommunityName}
                        {' '}
                        name.
                    </p>

                    <h3 className={styles.helpQuestions} id="bulletin-notification">
                        How do I sign up to be notified when a new
                        {' '}
                        {multiPubs}
                        {' '}
                        is posted?
                    </h3>
                    <p>
                        Visit your
                        {' '}
                        {churchCommunityName}
                        &apos;s listing page, scroll down to the
                        <b> Recent Publications</b>
                        &nbsp;
                        and select
                        &nbsp;
                        <b>Subscribe</b>
                        &nbsp;
                        and enter your name and e-mail address in the pop-up window.
                        You will now be notified when a new publication is ready to be viewed.
                    </p>
                    <div>
                        <img
                            className={styles.polMcoImages}
                            src={subscribeUrlImg}
                            width={
                                themeContext === POL_THEME
                                    ? '1553'
                                    : '1491'
                            }
                            height={
                                themeContext === POL_THEME
                                    ? '792'
                                    : '746'
                            }
                            alt="Subscribe button"
                        />
                    </div>

                    <h3 className={styles.helpQuestions} id="find-business">How do I find a business?</h3>
                    <p>
                        In the main navigation, select a category and enter a location for your search. Local businesses
                        that support
                        {' '}
                        {catholicCommunityName}
                        {' '}
                        will be returned. Additionally, businesses that support a specific&nbsp;
                        {parishCommunityName}
                        {' '}
                        are linked to that
                        {' '}
                        {parishCommunityName}
                        &apos;s listing page.
                    </p>

                    <h3 className={styles.helpQuestions} id="existing-listing">
                        How did my business or
                        &nbsp;
                        {churchOrgName}
                        {' '}
                        get on
                        &nbsp;
                        {siteName}
                        ?
                    </h3>
                    <p>
                        All customers of LPi automatically get a free listing page.
                        {' '}
                        {siteName}
                        {' '}
                        provides more
                        visibility for your
                        {' '}
                        {orgList}
                        .
                    </p>

                    <h3 className={styles.helpQuestions} id="claim-listing">How do I claim my listing?</h3>
                    <p>
                        First, you&apos;ll need to create a user account on
                        {' '}
                        {siteName}
                        . This creates an identity unique
                        to you. Part of this process is creating a login you&apos;ll use to access your listing in the
                        future. You can&apos;t claim a listing if
                        {' '}
                        {siteName}
                        {' '}
                        doesn&apos;t know who you are, so signing
                        in is how
                        {' '}
                        {siteName}
                        {' '}
                        remembers you. Click on the &quot;Log in&quot; button on the upper right
                        corner of the screen and follow the on-screen instructions to create your login.
                    </p>
                    <p>
                        You won&apos;t need your login to use
                        {' '}
                        {siteName}
                        {' '}
                        to search for your own or other
                        {' '}
                        {churchCommunityNamePlural}
                        {' '}
                        and businesses, but you will need it to access your listing page and make changes.
                    </p>
                    <p>
                        <strong>
                            Once you&apos;ve logged in using your login information, follow these steps to claim your
                            listing:
                            {' '}
                        </strong>
                    </p>
                    <div className={styles.instructionsContainer}>
                        <div>
                            <ol>
                                <li>
                                    Navigate to your listing page by searching your business or
                                    {' '}
                                    {churchOrgName}
                                    {' '}
                                    name on&nbsp;
                                    <a href={siteURL}>
                                        {siteStripedURLPretty}
                                    </a>
                                    .
                                </li>
                                <li>
                                    When you arrive at your listing page: scroll down to the &quot;
                                    {registerLinkText}
                                    &quot; button at the bottom of the page (
                                    <em>pictured below</em>
                                    ), and follow the steps on screen. This action allows the owner
                                    of the listing to make
                                    changes to the main information on that page.
                                    {' '}
                                    {listingOwnerText}
                                    <br />
                                    <div className={styles.imgContainer}>
                                        <img
                                            className={styles.image}
                                            src={supportImage}
                                            width="328"
                                            height="165"
                                            alt="Register as Staff button"
                                        />
                                    </div>
                                </li>
                                <li>
                                    You may need to wait up to 48 hours for LPi approval once
                                    you&apos;ve followed the steps above.
                                    {' '}
                                    {verifyText}
                                    {' '}
                                    to ensure that a third party isn&apos;t attempting to take ownership
                                    of your page without the right to do so.
                                </li>
                            </ol>
                        </div>
                    </div>
                    <p>
                        Once you&apos;ve received approval, you can log in to your listing page and start adding
                        information.
                    </p>

                    <h3 className={styles.helpQuestions} id="edit-listing">
                        How can I edit the information on my listing?
                    </h3>
                    <p>
                        Before you can edit your listing, you will need to
                        <a href="#claim-listing"> claim your listing</a>
                        . Once your listing is claimed, log in to your account
                        and find your listing page. Each section of
                        your page is directly editable. Move your cursor over the
                        section that needs to be changed, and
                        click the button in the upper right corner of the section you
                        would like to edit. Once changes are
                        made and saved within each section, they are instantly updated on your listing.
                    </p>

                    <h3 className={styles.helpQuestions} id="forgot-login">I forgot my login information.</h3>
                    <p>
                        If you have already established your login information and need a reminder, click on the
                        &quot;Log In&quot; button on the header. On the pop-up, click on the &quot;Forgot your
                        password?&quot; link. Follow the steps on your screen to reset your password.
                    </p>

                    <h3 className={styles.helpQuestions} id="post-bulletins">
                        How do I post my
                        {' '}
                        {howPostText}
                        ?
                    </h3>
                    <p>
                        If your
                        {' '}
                        {pubTypeNameAlt}
                        {' '}
                        is printed by LPi, it&apos;s automatically posted to your listing page once it has
                        been printed.However, if you aren&apos;t an LPi bulletin customer or would like to post
                        additional files, you can upload them manually.
                    </p>
                    <p>
                        <b>Step 1:</b>
                        &nbsp;
                        Log into your account and visit your
                        {' '}
                        {siteName}
                        {' '}
                        listing page.
                        <br />
                        Select
                        &nbsp;
                        <b>Manage Publications</b>
                        &nbsp;
                        found under the admin section:
                    </p>
                    <div>
                        <img
                            className={styles.polMcoImages}
                            src={managePublicationsUrlImg}
                            width={
                                themeContext === POL_THEME
                                    ? '1497'
                                    : '381'
                            }
                            height={
                                themeContext === POL_THEME
                                    ? '808'
                                    : '148'
                            }
                            alt="Manage Publications button"
                        />
                    </div>
                    <p>
                        <b>Step 2:</b>
                        &nbsp;
                        Under the tab
                        &nbsp;
                        <b>Publications,</b>
                        &nbsp;
                        select
                        &nbsp;
                        <b>Add Publications</b>
                    </p>
                    <div>
                        <img
                            className={styles.polMcoImages}
                            src={addFileUrlImg}
                            width={
                                themeContext === POL_THEME
                                    ? '409'
                                    : '815'
                            }
                            height={
                                themeContext === POL_THEME
                                    ? '199'
                                    : '296'
                            }
                            alt="Add File button"
                        />
                    </div>
                    <p>
                        <b>Step 3:</b>
                        &nbsp;
                        Select
                        &nbsp;
                        <b>Choose File</b>
                        &nbsp;
                        to browse your computer and upload your desired pdf file
                        or Drag and Drop your pdf file into the upload container. Enter additional information
                        about your publication and schedule its display date. Then select
                        &nbsp;
                        <b>Add Publication</b>
                        . Your file will automatically show up in your Recent Publications list.
                        Additionally, a thumbnail of the first page will display on the listing page.
                    </p>
                    <h3 className={styles.helpQuestions} id="bulletin-duration">
                        How long will published
                        {' '}
                        {pubTypeName}
                        s
                        {' '}
                        stay on my
                        {' '}
                        {siteName}
                        &nbsp;listing?
                    </h3>
                    <p>
                        {siteName}
                        {' '}
                        currently posts the 12 most recent issues.
                    </p>

                    <h3 className={styles.helpQuestions} id="bulletin-changes">
                        Can I make changes to
                        {' '}
                        {pubTypeNameAlt}
                        s that are already published
                        online?
                    </h3>
                    <p>
                        The publications posted to
                        {' '}
                        {siteName}
                        {' '}
                        have already been printed and sent out. If
                        changes need to be made for any reason, please contact our customer service
                        department.
                    </p>

                    <h3 className={styles.helpQuestions} id="bulletin-display">
                        Can I get my
                        {' '}
                        {pubTypeNameAlt}
                        s to display on my
                        {' '}
                        {churchCommunityName}
                        &apos;
                        s website?
                    </h3>
                    <p>
                        Yes, you can display your
                        {' '}
                        {pubTypeNameAlt}
                        s on your own Web page by using the customizable
                        {' '}
                        {siteName}
                        {' '}
                        widget.
                    </p>
                    <p>
                        The widget is a window on your website, placed where you choose, in which members
                        can click on a cover image to open a digital version of your
                        {' '}
                        {orgPlural}
                        &apos;
                        s
                        {' '}
                        {pubTypeNameAlt}
                        {' '}
                        and/or download a PDF version of your
                        {' '}
                        {pubTypeNameAlt}
                        . Once it&apos;s installed, you don&apos;t need to do anything; your
                        {' '}
                        {pubTypeNameAlt}
                        {' '}
                        will appear in the widget automatically. In addition, your members can sign up to receive your
                        {' '}
                        {pubTypeNameAlt}
                        {' '}
                        automatically via e-mail, keeping them informed whether they&apos;re at Mass or not.
                    </p>
                    <p>
                        To install the
                        {' '}
                        {siteName}
                        {' '}
                        widget, you&apos;ll first need to have claimed your listing page.
                        If you haven&apos;t done so, directions can be found
                        &nbsp;
                        <a href="#polwidget-notification">here.</a>
                    </p>
                    <p>
                        If you&apos;re already using the widget, you know what a useful tool it is in providing your
                        members instant access to your
                        {' '}
                        {bulletinNewsPub}
                        {' '}
                        content right from your web page.
                    </p>
                    <p>
                        If the widget on your page has a blue header and a gray background, you&apos;re using the old
                        widget and should update it to gain access to updated features.
                    </p>
                    <p>
                        Whether you&apos;re adding the widget for the first time or updating from old to new, these
                        simple directions will help you add this tool to your site today:
                    </p>
                    <p>
                        <b>Step 1:</b>
                        {' '}
                        On your listing page, select
                        &nbsp;
                        <b>{`Add ${themeContext === POL_THEME ? 'Bulletin to Your Website' : 'Newsletter to Your Website'}`}</b>
                        &nbsp;
                        found under the admin section:
                    </p>
                    <div>
                        <img
                            className={styles.polMcoImages}
                            src={getWidgetUrlImg}
                            width={
                                themeContext === POL_THEME
                                    ? '1549'
                                    : '1513'
                            }
                            height={
                                themeContext === POL_THEME
                                    ? '804'
                                    : '598'
                            }
                            alt="Get Widget button"
                        />
                    </div>
                    <p>
                        <b>Step 2:</b>
                        &nbsp;
                        Select the correct verbiage for your widget. If you publish
                        &nbsp;
                        <b>
                            {pubTypeName}
                            s
                        </b>
                        &nbsp;
                        with LPi, select that option. If you publish and display other
                        files on your
                        {' '}
                        {parishOrgName}
                        &apos;
                        s page, you may elect to use
                        &nbsp;
                        <b>Publications</b>
                        .
                    </p>
                    <p>
                        <b>Step 3:</b>
                        &nbsp;
                        A text box will display special HTML code you can use to embed
                        the widget on your website. Select
                        &nbsp;
                        <b>Get Widget Code</b>
                        &nbsp;
                        to copy the HTML code in the text box.
                    </p>
                    <div>
                        <img
                            className={styles.polMcoImages}
                            src={widgetCodeUrlImg}
                            width={
                                themeContext === POL_THEME
                                    ? '1251'
                                    : '430'
                            }
                            height={
                                themeContext === POL_THEME
                                    ? '805'
                                    : '203'
                            }
                            alt="Copy Widget Code button"
                        />
                    </div>
                    <p>
                        If you manage your
                        {' '}
                        {parishCommunityName}
                        &apos;
                        s website, To embed the widget, find the Widget section of your website editor,
                        select HTML and embed the code in the suggested space.
                    </p>
                    <p>
                        Unless you also manage and regularly make changes to your website, you’ll need to pass
                        this code along to your webmaster, who will paste it into your website in the appropriate
                        location and ensure the widget functions correctly.
                    </p>
                    <p>
                        This widget can be added to any Web page and will show the most recent printed publications.
                        Just select a
                        {' '}
                        {pubTypeNameAlt}
                        &apos;s
                        thumbnail and it will open on
                        {' '}
                        {siteName}
                        .
                    </p>
                </section>
                <div className={styles.leftContactContainer}>
                    <h6 className={headlineColor}>Webinars</h6>
                    <p>
                        Our free webinars are designed to help parish leaders and staff learn the foundational
                        building blocks and best practices for creating a vibrant parish. Sign up&nbsp;
                        <a target="_blank" href="http://4lpi.com/webinar-series" rel="noreferrer">here.</a>
                    </p>
                </div>
                <div className={styles.rightContactContainer}>
                    <h6 className={headlineColor}>Contact us</h6>
                    <p>For more help about our products, please don&apos;t hesitate to contact us today.</p>
                    <a
                        className="button"
                        target="_blank"
                        href="https://www.4lpi.com/contact-us"
                        rel="noreferrer"
                    >
                        <Button>Contact Us</Button>
                    </a>
                </div>
            </main>
        </div>
    );
};

export default Help;
